import axios from "axios";

import parseAppointmentData from '../../../parsers/AppointmentDataParser'

const getAppointmentListByDate = async (baseUrl, token, doctorId, startdate, enddate) => {

    const config = {
        headers: { Authorization: `Bearer ${token}` }
    };

    let getResponse = null

    await axios.get(baseUrl + "/doctor/" + doctorId + "/appointment?startdate="+ startdate + "&enddate=" + enddate, config)
        .then((res) => {
            let appointmentList = res.data.data

            let fixedAppointmentList = []
            for (let index = 0; index < appointmentList.length; index++) {
                const tempAppointment = appointmentList[index];
                fixedAppointmentList.push(parseAppointmentData(tempAppointment))
            }
            getResponse = {
                status: res.data.status,
                data: fixedAppointmentList
            }
        }).catch((error) => {
            if (error.response !== undefined) {
                getResponse = {
                    status: error.response.status,
                    data:  error.response.status
                }
            }
        });
    return getResponse
}

export default getAppointmentListByDate;